import styled from 'styled-components';

const YadoResortSectionTitleView = styled.p`
  color: var(--gray900);
  padding: 0;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: bold;
`;

export default YadoResortSectionTitleView
